/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Checkbox } from '@atoms';
import { Form } from '@organisms';

const ArticleChampionshipCheckbox = ({ labelClassName, checkButton, labelStyle, onChange, label, ...props }) => {
  const handleOnChange = React.useCallback(
    (event) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(event);
    },
    [onChange],
  );

  return (
    <Form.Item valuePropName="checked" {...props}>
      <Checkbox style={labelStyle} className={labelClassName} onChange={handleOnChange}>
        {label}
      </Checkbox>
    </Form.Item>
  );
};

export default ArticleChampionshipCheckbox;
